// extracted by mini-css-extract-plugin
module.exports = {"example":"FooterExample_example__1Gomr"};